import { RecordState } from '@gearbelt/global';
import { queryOptions } from '@tanstack/react-query';

import { ApiService } from '@/services/api-v2';
import { AWAApiV2Service } from '@/services/awa-api-v2';

export const unitKeys = {
  all: ['units'] as const,
  list: (isAWA: boolean) => [...unitKeys.all, 'list', isAWA] as const,
  details: () => [...unitKeys.all, 'detail'] as const,
  detail: (unitId: string | undefined, isAWA: boolean) => [...unitKeys.details(), unitId, isAWA] as const,
};

export const getUnitsQueryOptions = ({ isAWA = false }: { isAWA?: boolean } = {}) => {
  return queryOptions({
    queryKey: unitKeys.list(isAWA),
    queryFn: async () => (await (await (isAWA ? AWAApiV2Service : ApiService).GetUnits({ limit: 1000, filters: { state: RecordState.Active } })).json()).data,
  });
};

export const getUnitByIdQueryOptions = ({ unitId, isAWA = false }: { unitId: string | undefined; isAWA?: boolean }) => {
  return queryOptions({
    queryKey: unitKeys.detail(unitId, isAWA),
    queryFn: async () => {
      if (!unitId) throw new Error('Unit ID is required');
      return (await (isAWA ? AWAApiV2Service : ApiService).GetUnits({ limit: 1, filters: { fields: { id: [unitId] }, state: RecordState.Active } })).json();
    },
    enabled: !!unitId,
  });
};
